var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEncodingWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "#FFFFFF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 110,
    fill: "transparent"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.073 73.9801L40.5343 82.4079C36.9942 85.9021 31.2593 85.9021 27.7192 82.4079C24.1791 78.9138 24.1791 73.2533 27.7192 69.7592L44.8108 52.8895C48.3508 49.3953 54.0858 49.3953 57.6259 52.8895C58.8012 54.0495 60.7128 54.0495 61.9023 52.8895C63.0776 51.7294 63.0776 49.8426 61.9023 48.6685C55.9974 42.8403 46.4392 42.8403 40.5485 48.6685L23.4286 65.5522C17.5238 71.3804 17.5238 80.8146 23.4286 86.6289C29.3193 92.4571 38.8917 92.4571 44.7966 86.6289L53.3353 78.201C54.5106 77.0409 54.5106 75.1541 53.3353 73.9801C52.16 72.8061 50.2483 72.82 49.073 73.9801Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6427 23.3955C80.8308 17.5348 71.423 17.5348 65.611 23.3955L55.5203 33.5707C54.3635 34.7372 54.3635 36.6345 55.5203 37.8151C56.6771 38.9816 58.5587 38.9816 59.7294 37.8151L69.8202 27.6398C73.3045 24.1263 78.9492 24.1263 82.4336 27.6398C85.9179 31.1534 85.9179 36.8453 82.4336 40.3589L63.9385 59.0088C60.4542 62.5224 54.8095 62.5224 51.3251 59.0088C50.1683 57.8423 48.2868 57.8423 47.116 59.0088C45.9453 60.1753 45.9592 62.0726 47.116 63.2532C52.9279 69.1138 62.3357 69.1138 68.1337 63.2532L86.6288 44.6032C92.4546 38.7426 92.4546 29.2561 86.6427 23.3955Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEncodingWhite);
export default __webpack_public_path__ + "static/media/icon-encoding-white.4cb06cbe.svg";
export { ForwardRef as ReactComponent };